import safeAreaSingleton from '../../../utils/safeAreaSingleton';

/**
 * Get the height of the area that the sheet can be snapped to.
 * Note that this value is used for calculating the snap height, but the sheet can be dragged past this point.
 *
 * The sheet's own copy of this maths lives in the Roma family; what remains here is for app code that
 * needs to reason about how tall an open sheet is (keyboard obstructions, scroll-to-element, the emoji
 * list) without rendering one.
 */
export const getSheetSnapPointWindowHeight = () => window.innerHeight - safeAreaSingleton.getSafeArea().top;

export const getSnapPointSheetHeight = (snapPoint: number): number => snapPoint * getSheetSnapPointWindowHeight();
